export const buildPartnersGrouped = partnersData => {
    if (!partnersData) return [];

    const map = {};

    Object.values(partnersData).forEach(partner => {
        const {id, name, site, logo_url, category_id, category_name} = partner;

        if (!map[category_id]) {
            map[category_id] = {category_id, title: category_name, items: []};
        }

        map[category_id].items.push({id, name, site, logo_url});
    });

    return Object.values(map).sort((a, b) => a.category_id - b.category_id);
};
